import React, { useState, useEffect } from 'react';
import { Button, Text, Collapse } from "@chakra-ui/react";

export default function CollapseComponent(props) {
    const [show, setShow] = useState(false)
    const handleToggle = () => setShow(!show)
    
    return (
    <>
    <Collapse startingHeight={70} in={show}>
    <Text as="div" dangerouslySetInnerHTML={{ __html: `${props.collapseText}` }}></Text>
    </Collapse>
    <Button size="sm" onClick={handleToggle} mt="1rem" colorScheme="cyan">
    Show {show ? "Less" : "More"}
    </Button>
    </>
    )
}